
export class StringUtils {

    /* combined split('.') and pop() functions */
    public static splitPopWithDot( inputString: string ): string {
        return inputString.split('.').pop();   
    }

}
